module.exports = __webpack_public_path__ + "assets/img/dd315645de20d15ca3a1b78a8b902fff.webp";